import { createFileRoute } from "@tanstack/react-router";
/**
 * Invite User Page
 *
 * This page renders a breadcrumb navigation and the InviteUserForm component.
 *
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CommissionsForm } from "./-form";
import { getGetUserQueryOptions } from "@/requests/gen/react-query/user";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import snakeToCamel from "@/lib/snake-to-camel";
import { UserCrumbs } from "../../-crumbs";
import { UserRoleEnum } from "@/requests/gen/react-query/fastAPI.schemas";

export const Route = createFileRoute(
  "/_private/_admin/user/$userId/commissions/",
)({
  loader: ({ context: { queryClient }, params: { userId } }) =>
    queryClient.ensureQueryData(getGetUserQueryOptions(userId)),
  component: CommissionsPage,
});

function CommissionsPage() {
  const { userId } = Route.useParams();
  const { data: user } = useSuspenseQuery(
    suspenseOptions(getGetUserQueryOptions(userId)),
  );

  return (
    <div>
      <title>{`Edit ${user?.first_name} ${user?.last_name} Commissions - Legrande Health Portal`}</title>
      <UserCrumbs isSalesAdvisor={user?.role === UserRoleEnum.sales_advisor} />

      {/* User form */}
      <Card>
        <CardHeader>
          <CardTitle>Commissions</CardTitle>
          <CardDescription>
            {!user ? (
              <span className="animate-pulse">Loading...</span>
            ) : (
              <span>
                Set the entities for
                <span className="font-semibold">
                  {" "}
                  {snakeToCamel(user?.role)}
                </span>
                <span className="font-semibold">
                  {" "}
                  {user?.first_name} {user?.last_name}{" "}
                </span>
                below.
              </span>
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>{user && <CommissionsForm user={user} />}</CardContent>
      </Card>
    </div>
  );
}
